export function formatFileSize(size) {
	const units = ['Bytes', 'KB', 'MB', 'GB'];
	let unitIndex = 0;
	let numericSize = Number(size);

	if (!Number.isFinite(numericSize) || numericSize < 0) {
		return '';
	}

	while (numericSize >= 1024 && unitIndex < units.length - 1) {
		numericSize /= 1024;
		unitIndex++;
	}

	return `${numericSize.toFixed(2)} ${units[unitIndex]}`;
}